// extracted by mini-css-extract-plugin
export default {"popup_container":"DetailsContainer_popup_container__sVYPg","popup_header":"DetailsContainer_popup_header__lJ41A","popup_body":"DetailsContainer_popup_body__C6wZs"};